export class Mod_TerrainRegion {
	constructor(data: Partial<Mod_TerrainRegion>) { Object.assign(this, data); }
	terrainID = "";
}